import { memo } from "react"

type LabelsListProps = {
  labels: string[]
  onRemove: (index: number) => void
}

const LabelsList = memo(({ labels, onRemove }: LabelsListProps) => {
  return (
    <div className="flex flex-wrap gap-2 mb-2">
      {labels.map((label, idx) => (
        <span
          key={label} // better than idx
          className="inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-800 rounded"
        >
          {label}
          <button
            type="button"
            onClick={() => onRemove(idx)}
            className="ml-1 font-bold"
          >
            ×
          </button>
        </span>
      ))}
    </div>
  )
})

export default LabelsList
